import React from 'react';
import { SetupTab } from 'areas/shared/pages/setup';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { Switch, TextBox, TextAreaBox } from 'fw/forms';
import { Label, Button, ActionButton } from 'fw/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as API from 'modules/app/API';
import * as App from 'modules/app/App';
import { CommentsGrid } from 'areas/shared/components';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel';
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import * as ReportManager from 'modules/reports/ReportManager';

class CapitalContribution extends SetupTab {
    initialForm() {
        return {
            certificationId: "",
            certificationKey: "",
            loans: false,
            rowVersion: null,
            moneyContributions: [],
            equipmentContributions: [],
            realStateContributions: [],
            experienceContributions: [],
            otherContributions: [],
            reviewComment: ''

        }
    }

    urls() {
        return {
            get: API.Admin.url('/siteReview/getCapitalContribution'),
            save: API.Admin.url('/siteReview/saveCapitalContribution')
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege('AdminSiteReviewAccess'),
            edit: App.hasPrivilege('AdminSiteReviewAccess')
        }
    }

    saveRequest() {
        return {
            entityId: this.state.form.entityId,
            certificationId: this.state.form.certificationId,
            certificationKey: this.props.selectedId,
            moneyContributions: this.state.form.moneyContributions,
            equipmentContributions: this.state.form.equipmentContributions,
            realStateContributions: this.state.form.realStateContributions,
            experienceContributions: this.state.form.experienceContributions,
            otherContributions: this.state.form.otherContributions,
            loans: this.state.form.loans,
            loansDescription: this.state.form.loansDescription,
            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewComment: this.state.reviewComment
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    updatePostData = (form, dirty) => {
        for (var ref in this.refs) {
            this._form.register(this.refs[ref]);
        }
        this.setState({ form });

        if (dirty === true)
            this.dirt();
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    ready = () => {
        // If slected form is paper -> Redirect to FinalRecomm
        if (this.state.form.isPaperForm)
            window.location.href = `/admin/siteReview/${this.props.selectedId}/finalRecomm/${this.props.queueTypeCode}`;

        if (this.state.form.moneyContributions.length === 0)
            this.handleAddContribution("moneyContributions", false);
        if (this.state.form.equipmentContributions.length === 0)
            this.handleAddContribution("equipmentContributions", false);
        if (this.state.form.realStateContributions.length === 0)
            this.handleAddContribution("realStateContributions", false);
        if (this.state.form.experienceContributions.length === 0)
            this.handleAddContribution("experienceContributions", false);
    }

    handleFieldChange = (type, field, value, index) => {
        let form = this.state.form;
        form[type][index][field] = value;
        this.updatePostData(form, true);
    }

    handleRemoveContribution = (index, type) => {
        let form = this.state.form;
        form[type].splice(index, 1);
        this.updatePostData(form, true);
    }

    handleAddContribution = (type, dirty) => {
        let form = this.state.form;
        form[type].push({
            firstName: '',
            lastName: '',
            description: ''
        });
        this.updatePostData(form, dirty);
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form.reviewStatus = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleAppReviewToolbar = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    handleUpdate = (field, value) => {
        let form = this.state.form;
        form[field] = value;
        this.updatePostData(form, true);
    }

    renderContributions = (type) => {
        return this.state.form[type].map((item, index) => (
            <Row key={index} style={{ marginBottom: 20 }}>
                <Col md={11}>
                    <Label htmlFor="firstName" required>First Name</Label>
                    <TextBox
                        placeholder="First Name"
                        maxLength={50}
                        required
                        ref={`firstName_${type}_${index}`}
                        value={item.firstName}
                        onChange={value => this.handleFieldChange(type, "firstName", value, index)}
                        style={{ marginBottom: 10 }}
                    />
                    <Label htmlFor="lastName" required>Last Name</Label>
                    <TextBox
                        placeholder="Last Name"
                        maxLength={50}
                        required
                        ref={`lastName_${type}_${index}`}
                        value={item.lastName}
                        onChange={value => this.handleFieldChange(type, "lastName", value, index)}
                        style={{ marginBottom: 10 }}
                    />
                    <Label htmlFor="description" required>Contribution Description</Label>
                    <TextAreaBox
                        maxLength={500}
                        placeholder="Briefly describe Contribution here..."
                        required
                        ref={`description_${type}_${index}`}
                        value={item.description}
                        onChange={value => this.handleFieldChange(type, "description", value, index)}
                        style={{ marginBottom: 10 }}
                    />
                </Col>
                {type === "otherContributions" || index > 0 ?
                    <Col md={1} style={{ marginTop: 25, marginLeft: -15, paddingLeft: 0, textAlign: "left" }}>
						<Button type="button" bsStyle="link" onClick={() => this.handleRemoveContribution(index, type)} title="Remove Contributor">
                            <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
						</Button>
                    </Col>
                    : null}
            </Row>
        ));
    }

    blankLoansDescription = () => {
        let form = this.state.form;

        if (!form.loans)
            form.loansDescription = null;

        this.updatePostData(form, true);
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "SiteReviewCapitalContributionReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'CC'}
                queueTypeCode={'STR'}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={2}>
                        {this.state.form.showReview ?
                            <AppReviewToolbar
                                queueTypeCode={'STR'}
                                reviewTypeCode={'CC'}
                                comments={this.state.form.comments}
                                onFlagSave={this.handleAppReviewToolbar}
                                certificationKey={this.props.selectedId} />
                            : null}
                    </Col>
                    <Col md={4}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>
                                    {this.state.form.siteReviewTitle}
                                    {this.renderAdminStepToolbar()}
                                    <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: 0 }}>
                                    <small>Please list all the individuals and the contributions to the Company when it was formed/bought</small>
                                </h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <h4>Money Contributions:</h4>
                                <hr />
                                <FormGroup>
                                    {this.renderContributions("moneyContributions")}
                                </FormGroup>
        						{!this.state.form.isReviewFinished &&
									<Button type="button" bsStyle="link" onClick={() => this.handleAddContribution("moneyContributions", true)} style={{ marginBottom: 10, display: "block" }}>
										Add another Contributor
									</Button>
								}
                            </Col>
                            <Col md={6}>
                                <h4>Equipment Contributions:</h4>
                                <hr />
                                <FormGroup>
                                    {this.renderContributions("equipmentContributions")}
                                </FormGroup>
                                {!this.state.form.isReviewFinished &&
									<Button type="button" bsStyle="link" onClick={() => this.handleAddContribution("equipmentContributions", true)} style={{ marginBottom: 10, display: "block" }}>
										Add another Contributor
									</Button>
								}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <h4>Real Estate Contributions:</h4>
                                <hr />
                                <FormGroup>
                                    {this.renderContributions("realStateContributions")}
                                </FormGroup>
                                {!this.state.form.isReviewFinished &&
									<Button type="button" bsStyle="link" onClick={() => this.handleAddContribution("realStateContributions", true)} style={{ marginBottom: 10, display: "block" }}>
										Add another Contributor
									</Button>
								}
                            </Col>
                            <Col md={6}>
                                <h4>Experience Contributions:</h4>
                                <hr />
                                <FormGroup>
                                    {this.renderContributions("experienceContributions")}
                                </FormGroup>
                                {!this.state.form.isReviewFinished &&
									<Button type="button" bsStyle="link" onClick={() => this.handleAddContribution("experienceContributions", true)} style={{ marginBottom: 10, display: "block" }}>
										Add another Contributor
									</Button>
								}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <h4>Other Contributions:</h4>
                                <hr />
                                <FormGroup>
                                    {this.renderContributions("otherContributions")}
                                </FormGroup>
                                {!this.state.form.isReviewFinished &&
									<Button type="button" bsStyle="link" onClick={() => this.handleAddContribution("otherContributions", true)} style={{ marginBottom: 10, display: "block" }}>
										Add another Contributor
									</Button>
								}
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col md={6}>
                                <Label>Are there any loans to or from Shareholders?</Label>
                                <Switch
                                    name="loans"
                                    labelLeft="No"
                                    labelRight="Yes"
                                    bsStyle="success"
                                    onChange={this.blankLoansDescription}
                                />
                                {this.state.form.loans &&
                                    <Row>
                                        <Col md={11}>
                                            <TextAreaBox
                                                maxLength={500}
                                                name="loansDescription"
                                                placeholder="Briefly explain circumstances of all Loan(s) and Terms of Payment here..."
                                                required
                                            ></TextAreaBox>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={this.state.form.comments}
                        documents={this.state.form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={"CC"}
                        queueTypeCode={"STR"}
                        enableExport={true}
                        entityId={this.state.form.entityId}
                        readonly={!this.state.privileges.edit || !this.state.enabled}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange} />
                </Row>
                {this.state.form.showComplete ?
                    <Row>
                        <ReviewPanel stepName="Capital Contribution" onChange={this.handleReviewStatus} reviewStatus={this.state.form.reviewStatus} />
                    </Row>
                : null}
            </React.Fragment>
        )
    }
}

export default CapitalContribution; 



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/capitalContribution/CapitalContribution.js